import React, { Component } from 'react';
import { observer } from 'mobx-react';

import style from './MeetingPage.module.scss';
import { FormattedMessage } from 'react-intl';
import Button from 'components/Button/Button';
import ModalStore from 'stores/ModalStore';
import VideoPlayerModal from 'components/Modals/VideoPlayer/VideoPlayerModal';
import RootStore from 'stores/RootStore';

@observer
class MeetingPage extends Component {
  render() {
    return (
      <main className={style.main}>
        <span className={style.title}>
          <FormattedMessage id="page.meeting.title" />
        </span>
        <a
          href={this._link}
          className={style.link}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FormattedMessage id="page.meeting.link" />
        </a>
        <Button className={style.button} onClick={this._handleButtonClick}>
          <FormattedMessage id="page.meeting.button" />
        </Button>
      </main>
    );
  }

  private _handleButtonClick = () => {
    ModalStore.showModal(VideoPlayerModal, {
      titleId: 'page.meeting.modal.title',
      src: '/assets/media/sionum-meeting.mp4',
    });
  };

  private get _link() {
    return (
      RootStore.config.links?.meetingApp ?? 'https://meeting.sionum.cloud/'
    );
  }
}

export default MeetingPage;
